import React from 'react';
import Select from 'react-select';
import { useQuery } from '@tanstack/react-query';
import { fetchEmployeeTypes } from 'services/dropdown';
import { DROPDOWN_STALE_TIME } from 'utils/constants';
import { Controller } from 'react-hook-form';

const EmployeeTypeDropdown = ({ errors, control, setValue, getValues, watch }) => {

    const empTypeName = getValues().employee_type;
    const selectedEmpType = watch('id');

    const { data: empTypes, isLoading, error } = useQuery(
        ['employeeTypes'],
        () => fetchEmployeeTypes(),
        {
            keepPreviousData: false,
            staleTime: DROPDOWN_STALE_TIME,
        }
    );

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error loading Departments</div>;

    const options = empTypes?.data?.data?.map(empType => ({
        value: empType.id,
        label: empType.employee_type,
    })) || [];

    const selectedOption = options.find(option => option.value === selectedEmpType || empTypeName);

    return (
        <Controller
            name="id"
            control={control}
            rules={{ required: 'Employee Type is required' }}
            render={({ field }) => (
                <Select
                    {...field}
                    options={options}
                    isClearable
                    value={selectedOption || null}
                    placeholder="Select Employee Type"
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                    }}
                    onChange={(selectedOption) => {
                        const value = selectedOption ? selectedOption.value : '';
                        field.onChange(value);
                        setValue('id', value);
                    }}
                    className={`react-select-container ${errors.id ? 'is-invalid' : ''}`}
                />
            )}
        />
    );
};

export default EmployeeTypeDropdown;